<template>
  <div class="q-pa-sm">
    <task-queues
      :options="options"
      @select="onRowDblClick"
    />
  </div>
</template>

<script>
// Vuex
import { mapMutations } from 'vuex'

// Components
import TaskQueues from '../../components/queue/TaskQueues.vue'

export default {
  name: 'AssemblingByOrderQueues',
  components: {
    TaskQueues
  },
  computed: {
    options () {
      return {
        type: 'discrete_assembling',
        title: this.$t('Packing by order ID'),
        service: this.$service.assemblingQueue,
        adapters: ['discrete_assembling']
      }
    }
  },
  methods: {
    ...mapMutations([
      'setAssemblingQueue'
    ]),
    onRowDblClick ({ item, toFilters }) {
      this.setAssemblingQueue(item)
      const path = `/workstation/queues/packing/entity/${item.id}${toFilters ? '?start=true' : ''}`
      this.$router.push(path)
    }
  }
}
</script>
